import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import "../../../../cssfiles/homepage.css";
import { useDispatch, useSelector } from "react-redux";
import { de } from "date-fns/locale";
import { updatedevicelist } from "../../../../store/diagnostic_data";

export default function TableDevice(props) {
  const dispatch = useDispatch();

  const tagcollectionvalue = useSelector(
    (state) => state.mainpagedata.tagcollectionvalues
  );

  const sdate_edate_selected = useSelector(
    (state) => state.mainpagedata.selecteddates
  );

  const devicedetailsobject = useSelector(
    (state) => state.mainpagedata.devicedetailsobject
  );

  let projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );
  const selectedtreepath = useSelector(
    (state) => state.mainpagedata.treepathselected
  );
  if (selectedtreepath[selectedtreepath.length - 1] === "Delhi Works") {
    projectId = "3d808646-bff8-4406-ae3d-d63a19f26ddd";
  } else if (selectedtreepath[selectedtreepath.length - 1] === "Baroda Works") {
    projectId = "2041b177-a1e7-449b-8c33-5ed911543122";
  }
  const gatewaylist = useSelector((state) => state.diagnosticdata.gatewayList);

  const [tableHead, setTableHead] = useState([]);
  const [tableRows, setTableRows] = useState([]);

  useEffect(() => {
    let head_values = props.widgetprop.props.extended.column_categories;
    let rows_values = [];
    let name = [];
    let id = [];
    let sn = [];
    let cn = [];

    for (let key in devicedetailsobject) {
      if (
        devicedetailsobject[key].ProjectID === projectId ||
        projectId === "All"
      ) {
        name.push(devicedetailsobject[key].Name);
        id.push(devicedetailsobject[key].DeviceID);
        sn.push(devicedetailsobject[key].SN);
        for (let i = 0; i < gatewaylist.length; i++) {
          if (gatewaylist[i][0] === devicedetailsobject[key].GatewayID) {
            if (gatewaylist[i][2] === "Disconnected") {
              cn.push("Disconnected");
            } else if (gatewaylist[i][2] === "Connected") {
              if (devicedetailsobject[key].Status === 0) {
                cn.push("Disconnected");
              } else if (devicedetailsobject[key].Status === 1) {
                cn.push("Connected");
              }
            }
            break;
          }
        }
      }
    }

    rows_values = id.map((value, index) => [name[index], sn[index], cn[index]]);

    setTableHead(head_values);
    setTableRows(rows_values);
    dispatch(updatedevicelist(rows_values));
  }, [
    props.widgetprop,
    tagcollectionvalue,
    sdate_edate_selected,
    gatewaylist,
    de,
  ]);

  return (
    <>
      {tableRows.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            height: "100%",
            paddingLeft: "0px",
            backgroundColor: "var(--secondary-backgroundLK)",
            paddingRight: "0px",
          }}
          elevation={0}
        >
          <Table stickyHeader sx={{ width: "100%" }} size="small">
            <TableHead>
              <TableRow sx={{ border: "0px" }}>
                {tableHead.map((table_head_value, index) => (
                  <TableCell
                    key={index + 1}
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablehead.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablehead.fontweight,
                      color: "var(--grey-variation-tableLK)",
                      backgroundColor: "var(--secondary-backgroundLK)", // Ensure background color is set
                    }}
                  >
                    {table_head_value}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableRows.map((row, index) => (
                <TableRow
                  key={index + 1}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    height: "9px",
                    "& > *": {
                      borderBottom: "1px solid var(--table-boarder-line)",
                    },
                  }}
                >
                  {row.map((row_value, row_index) => (
                    <TableCell
                      key={row_index + 1}
                      component="th"
                      scope="row"
                      sx={{
                        fontSize:
                          props.widgetprop.props.extended.tablerows.fontsize,
                        fontWeight:
                          props.widgetprop.props.extended.tablerows.fontweight,
                        color:
                          row_value === "Connected" || row_value === "ON TARGET"
                            ? "#00943D"
                            : row_value === "Disconnected" ||
                              row_value === "DEVIATED BY 3%"
                            ? "#DC272D"
                            : "var(--grey-variation-tablerowsLK)",
                      }}
                    >
                      {row_value}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
